"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var router_1 = require("@angular/router");
var services_1 = require("../../services");
var constants_1 = require("../../constants");
var LevelsBoxComponent = (function () {
    function LevelsBoxComponent(activatedRoute, router, packLevelService, localizationService, eventService, progressService) {
        this.activatedRoute = activatedRoute;
        this.router = router;
        this.packLevelService = packLevelService;
        this.localizationService = localizationService;
        this.eventService = eventService;
        this.progressService = progressService;
        this.retina = constants_1.RETINA;
    }
    LevelsBoxComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.renderInterfaceLocals()
            .then(function () {
            _this.routerSubscribe();
            _this.subscribeOnEvents();
            _this.setRouterLink();
        });
    };
    LevelsBoxComponent.prototype.ngOnDestroy = function () {
        this.setTitleInHead();
        this.eventService.fire('getStarsProgress');
        this.unSubscribeFromEvents();
    };
    LevelsBoxComponent.prototype.subscribeOnEvents = function () {
        var _this = this;
        this.subscriptionChangeLocalsEvent = this.eventService.subscribe('changeLocals', function () {
            _this.setRouterLink();
            _this.renderInterfaceLocals()
                .then(function () {
                _this.setTitleInHead(_this.interfaceLocals[_this.packId]);
            });
            _this.renderLevelInfos();
            _this.setPrevNextLinks();
        });
        this.subscriptionProgressSyncEvent = this.eventService.subscribe('progressSynced', function () {
            _this.localizationService.interfaceLocals
                .then(function () {
                _this.assignStats();
                _this.renderLevelInfos();
                _this.getStarsProgress();
            });
        });
    };
    LevelsBoxComponent.prototype.unSubscribeFromEvents = function () {
        this.subscriptionChangeLocalsEvent.unsubscribe();
        this.subscriptionRouter.unsubscribe();
    };
    LevelsBoxComponent.prototype.renderLevelInfos = function () {
        var _this = this;
        this.localizationService.levelLocals
            .then(function (levels) {
            _this.levelLocals = levels;
            var levelOptions = [];
            for (var _i = 0, _a = _this.levels; _i < _a.length; _i++) {
                var level = _a[_i];
                levelOptions.push({
                    level: level,
                    levelLocals: _this.levelLocals,
                    levelIcon: 'icon-' + level.levelId + 'Icon',
                    isLocked: _this.isLocked(level.levelId),
                    isTutorial: level.tutorial,
                    levelNumber: level.levelNumber,
                    stars: _this.stats[level.levelId],
                    levelId: level.levelId
                });
            }
            _this.levelOptions = levelOptions;
        });
    };
    LevelsBoxComponent.prototype.routerSubscribe = function () {
        var _this = this;
        this.subscriptionRouter = this.activatedRoute.params.subscribe(function (params) {
            var packId = params.packId;
            _this.packNumber = _this.packLevelService.numberForPackWithId(packId);
            _this.levels = _this.packLevelService.levelsInPackId(packId);
            _this.packId = packId;
            _this.assignStats();
            _this.renderLevelInfos();
            _this.setPrevNextPacks();
            _this.setPrevNextPacksUnlocked();
            _this.setPrevNextLinks();
            _this.getStarsProgress();
            _this.setTitleInHead(_this.interfaceLocals[packId]);
        });
    };
    LevelsBoxComponent.prototype.assignStats = function () {
        this.stats = this.calcStats();
    };
    LevelsBoxComponent.prototype.getStarsProgress = function () {
        var starsEarned = this.progressService.starsEarnedWithPackId(this.packId);
        var limitStars = this.packLevelService.starsCountForPackId(this.packId);
        this.eventService.fire('getStarsProgress', [starsEarned, limitStars]);
    };
    LevelsBoxComponent.prototype.renderInterfaceLocals = function () {
        var _this = this;
        return this.localizationService.interfaceLocals
            .then(function (locals) {
            _this.interfaceLocals = locals;
        });
    };
    LevelsBoxComponent.prototype.setPrevNextLinks = function () {
        this.prevPackLink = this.setRouterLink(this.prevPack);
        this.nextPackLink = this.setRouterLink(this.nextPack);
    };
    LevelsBoxComponent.prototype.setPrevNextPacks = function () {
        this.prevPack = this.packLevelService.previousPackId(this.packId);
        this.nextPack = this.packLevelService.nextPackId(this.packId);
    };
    LevelsBoxComponent.prototype.setPrevNextPacksUnlocked = function () {
        this.isPrevPackUnlocked = this.isPackUnlocked(this.prevPack);
        this.isNextPackUnlocked = this.isPackUnlocked(this.nextPack);
    };
    LevelsBoxComponent.prototype.isLocked = function (levelId) {
        return this.progressService.isLevelLocked(levelId);
    };
    LevelsBoxComponent.prototype.calcStats = function () {
        var stats = {};
        for (var _i = 0, _a = this.levels; _i < _a.length; _i++) {
            var level = _a[_i];
            var levelId = level.levelId;
            var levelResult = this.progressService.levelsResults[levelId];
            var stars = {};
            if (levelResult && levelResult.stars && levelResult.stars.length != 0) {
                var resultStars = levelResult.stars;
                for (var j = 0; j < resultStars.length; j++) {
                    stars[resultStars[j]] = resultStars[j];
                }
            }
            else {
                stars = {};
            }
            stats[levelId] = stars;
        }
        return stats;
    };
    LevelsBoxComponent.prototype.setRouterLink = function (packId) {
        var path = this.localizationService.getRootUrl();
        if (packId) {
            path = path + '/' + packId;
            return path;
        }
        this.backLink = path;
    };
    LevelsBoxComponent.prototype.isPackUnlocked = function (packId) {
        if (!packId) {
            return false;
        }
        return !this.progressService.isPackLocked(packId);
    };
    LevelsBoxComponent.prototype.setTitleInHead = function (title) {
        this.localizationService.setTitleInHead(title);
    };
    return LevelsBoxComponent;
}());
LevelsBoxComponent = __decorate([
    core_1.Component({
        selector: 'levels-box-component',
        template: require('./levels-box.component.pug'),
        styles: [require('./levels-box.component.scss')]
    }),
    __metadata("design:paramtypes", [router_1.ActivatedRoute,
        router_1.Router,
        services_1.PackLevelService,
        services_1.LocalizationService,
        services_1.EventService,
        services_1.ProgressService])
], LevelsBoxComponent);
exports.LevelsBoxComponent = LevelsBoxComponent;



//////////////////
// WEBPACK FOOTER
// ./src/components/levels-box/levels-box.component.ts
// module id = 243
// module chunks = 0